<template>
  <div class="overflow-hidden">
    <section class="cp-page py-4">
      <header-help :is-loading="isLoading"></header-help>

      <!-- Background animated orbs using Stella brand colors -->
      <div class="cp-bg-orb cp-bg-orb--1"></div>
      <div class="cp-bg-orb cp-bg-orb--2"></div>

      <div class="container position-relative my-auto" style="z-index: 1;">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
            <div class="cp-content-card p-4 p-md-5 text-center">
              
              <!-- Celebration Glow Heart -->
              <div class="avatar-glow-wrapper mb-3">
                <div class="d-inline-flex align-items-center justify-content-center" 
                     style="width: 76px; height: 76px; border-radius: 50%; background: linear-gradient(135deg, rgba(243,218,107,0.2), rgba(229,59,185,0.2)); border: 2px solid #F3DA6B; box-shadow: 0 0 35px rgba(243, 218, 107, 0.4);">
                  <span style="font-size: 32px;">💖</span>
                </div>
              </div>

              <h2 class="text-white font-weight-700 mb-2">Tip Sent! 🎉</h2>
              
              <!-- Highlight Pill -->
              <div class="d-inline-flex align-items-center px-3 py-2 rounded-pill mb-3" 
                   style="background: rgba(243,218,107,0.12); border: 1px solid rgba(243,218,107,0.3);">
                <span class="font-weight-700 font-size-15 text-warning me-1">${{ amount || '10' }}</span>
                <span class="text-white-50 font-size-13">sent to <strong class="text-white">@{{ invitee.name }}</strong></span>
              </div>

              <p class="text-white-50 font-size-14 mb-4">
                @{{ invitee.name }} has been notified of your support. Your personal message has been delivered to their inbox!
              </p>

              <!-- Action Button -->
              <div class="mt-4">
                <button type="button"
                        class="cp-btn-primary px-4"
                        @click="finish()">
                  Continue to Direct Chat <i class="fa fa-arrow-right ms-2"></i>
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import LoadingModal from "@/components/module/shared/LoadingModal";
import HeaderHelp from "@/components/module/influencer/shared/HeaderHelp";
import {igValidationMixin} from "@/mixin/ig-validation-mixin";
import {customerAccountMixin} from "@/mixin/customer-account/customer-account-mixin";
import titleMixin from "../../../../mixin/title-mixin";
import {paymentPaid, TIP} from "@/common/analytics-service";

export default {
  name: 'TipPaymentComplete',
  title: 'Tip Payment Complete',
  mixins: [igValidationMixin, customerAccountMixin, titleMixin],
  components: {LoadingModal, HeaderHelp},
  data() {
    return {
      invitee: {name: ''},
      amount: '',
    }
  },
  created() {
    this.invitee = this.getInvitee;
    this.amount = localStorage.getItem('tip') || '10';
    this.setMessage(`Your $${this.amount} tip to @${this.invitee.name || 'creator'} was sent successfully!`);
  },
  mounted() {
    paymentPaid(this, TIP, this.invitee);
  },
  methods: {
    ...mapActions(['setMessage']),
    finish() {
      let donate = this.$route.query.donate;
      if (this.getCreatePlatform || donate) {
        this.showCustomerContent();
      } else {
        this.$router.replace({name: 'MessageCta', query: {saved: true}});
      }
    }
  }
}
</script>
